<template>
	<form @submit.prevent="save">
		<p class="text-muted">
			For <strong>{{ employeeName || 'employee' }}</strong> on {{ formatDate(workDate) }}.
		</p>
		<div v-if="error" class="alert alert-danger">{{ error }}</div>
		<div class="row">
			<div class="col-sm-6 form-group">
				<label>Sales</label>
				<input v-model.number="form.sales_count" type="number" min="0" step="1" required class="form-control form-cascade-control" />
			</div>
			<div class="col-sm-6 form-group">
				<label>No. of references</label>
				<input v-model.number="form.reference_count" type="number" min="0" step="1" required class="form-control form-cascade-control" />
			</div>
			<div class="col-sm-6 form-group">
				<label>Visit count</label>
				<input v-model.number="form.visit_count" type="number" min="0" step="1" required class="form-control form-cascade-control" />
			</div>
			<div class="col-sm-6 form-group">
				<label>Deliveries</label>
				<input v-model.number="form.delivery_count" type="number" min="0" step="1" required class="form-control form-cascade-control" />
			</div>
			<div class="col-sm-6 form-group">
				<label>Completed social-media tasks</label>
				<input v-model.number="form.social_media_count" type="number" min="0" step="1" required class="form-control form-cascade-control" />
			</div>
			<div class="col-sm-6 form-group">
				<label>Today's collection</label>
				<input v-model.number="form.collection_amount" type="number" min="0" step="0.01" required class="form-control form-cascade-control" />
			</div>
		</div>
		<div class="text-right" style="margin-top:12px">
			<button type="button" class="btn btn-default" @click="$emit('cancel')">Cancel</button>
			<button type="submit" class="btn btn-primary" :disabled="saving">
				{{ saving ? 'Saving…' : 'Save performance' }}
			</button>
		</div>
	</form>
</template>

<script>
import { performanceService, errorMessage } from './attendanceService'
import attendanceFormat from './attendanceFormat'

export default {
	name: 'AttendancePerformanceForm',
	mixins: [attendanceFormat],
	props: {
		employeeId: { type: [Number, String], required: true },
		employeeName: { type: String, default: '' },
		workDate: { type: String, required: true },
		performance: { type: Object, default: null },
	},
	data() {
		return {
			form: this.blankForm(),
			saving: false,
			error: '',
		}
	},
	methods: {
		blankForm() {
			return { sales_count: 0, reference_count: 0, visit_count: 0, delivery_count: 0, social_media_count: 0, collection_amount: 0 }
		},
		reset(value = this.performance) {
			this.form = value
				? {
						sales_count: Number(value.sales_count || 0),
						reference_count: Number(value.reference_count || 0),
						visit_count: Number(value.visit_count || 0),
						delivery_count: Number(value.delivery_count || 0),
						social_media_count: Number(value.social_media_count || 0),
						collection_amount: Number(value.collection_amount || 0),
				  }
				: this.blankForm()
			this.error = ''
		},
		save() {
			this.saving = true
			this.error = ''
			performanceService
				.save({ employee_id: this.employeeId, work_date: this.workDate, ...this.form })
				.then((row) => this.$emit('saved', row))
				.catch((e) => { this.error = errorMessage(e, 'Could not save performance.') })
				.finally(() => { this.saving = false })
		},
	},
}
</script>
